module.exports = __webpack_public_path__ + "static/media/Sarabun-Italic.31417f51.ttf";